"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("@elrond-giants/erdjs-auth/dist/types");
const StateStorage_1 = __importDefault(require("./StateStorage"));
const erdjs_auth_1 = require("@elrond-giants/erdjs-auth");
const STORAGE_KEY = ".erd.auth";
class AuthConnector {
    constructor(builder, storage = null) {
        this._onChange = () => { };
        this.builder = builder;
        this.storage = storage !== null && storage !== void 0 ? storage : new StateStorage_1.default();
    }
    set onChange(value) {
        this._onChange = value;
    }
    get provider() {
        return this._provider ? this._provider : null;
    }
    init(providerType, options = { shortLived: false }) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.initProvider(this.builder.buildProvider(providerType), options);
        });
    }
    saveState() {
        this.assertInitialised();
        // @ts-ignore
        this.storage.storeItem(STORAGE_KEY, this._provider.toJson());
    }
    initFromStorage() {
        return __awaiter(this, void 0, void 0, function* () {
            const state = this.storage.getItem(STORAGE_KEY);
            if (null === state || state.authProviderType === types_1.AuthProviderType.NONE) {
                return false;
            }
            return this.initProvider(this.builder.buildProvider(state.authProviderType), state);
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            this.assertInitialised();
            // @ts-ignore
            const result = yield this._provider.logout();
            this.reset();
            return result;
        });
    }
    initialised() {
        return this._provider !== undefined;
    }
    initProvider(provider, { address, authenticated, shortLived }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (provider instanceof erdjs_auth_1.WebProvider && address !== undefined) {
                provider.setState({
                    address,
                    authenticated: authenticated !== null && authenticated !== void 0 ? authenticated : !!address
                });
            }
            provider.on("login", () => {
                if (!shortLived) {
                    this.saveState();
                }
                this._onChange();
            });
            provider.on("logout", () => {
                if (!shortLived) {
                    this.saveState();
                }
                this.reset();
            });
            this._provider = provider;
            const initialised = yield this._provider.init();
            if (!shortLived) {
                this.saveState();
            }
            return initialised;
        });
    }
    assertInitialised() {
        if (!this.initialised()) {
            throw new Error("Auth connector must be initialised.");
        }
    }
    reset() {
        this.storage.removeItem(STORAGE_KEY);
        delete this._provider;
        this._onChange();
    }
}
exports.default = AuthConnector;
;
